import React, { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

const SingleNumberInput = ({ onChange, filter: { value = '' } = {}}) => {
    const [v, setV] = useState(value);

    useEffect(() => {
        setV(value)
    }, [value])
    const debouncedChangeHandler = useCallback(
        debounce(onChange, 400)
    , []);
    return (
        <input
            type="number"
            style={{ width: '100%'}}
            value={v} 
            onChange={(e) => {
                setV(e.target.value);
                debouncedChangeHandler(e.target.value)
            }}
        />
    );
}

export default SingleNumberInput;